import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("UI crash caught by ErrorBoundary:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[60vh] flex flex-col items-center justify-center text-center p-8" data-testid="error-boundary">
          <div className="w-14 h-14 rounded-full bg-[#f0f7f8] flex items-center justify-center mb-4">
            <span className="text-[#3A7A8C] text-2xl">!</span>
          </div>
          <h2 className="text-2xl font-bold text-[#3C4048] mb-2" style={{ fontFamily: "Montserrat", fontWeight: 800 }}>
            Something went wrong
          </h2>
          <p className="text-[#7A9090] mb-6 max-w-sm">
            This section hit an unexpected error. Reloading usually fixes it.
          </p>
          <button
            data-testid="error-reload-button"
            onClick={() => window.location.reload()}
            className="bg-[#5FA8B4] hover:bg-[#3A7A8C] text-white font-semibold px-5 py-2.5 rounded-[12px] transition-colors"
          >
            Reload page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
